import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import dayjs from 'dayjs';
export interface notice {
  parcelImageUrl: string;
  parcelImageLink: string;
  quickImageUrl: string;
  quickImageLink: string;
  mailImageUrl: string;
  mailImageLink: string;
  globalImageUrl: string;
  globalImageLink: string;
}

interface isShowToday {
  [key: string]: string;
  quick: string;
  parcel: string;
  registry: string;
  global: string;
}

export class noticeState {
  notice: notice = {
    parcelImageUrl: '',
    parcelImageLink: '',
    quickImageUrl: '',
    quickImageLink: '',
    mailImageUrl: '',
    mailImageLink: '',
    globalImageUrl: '',
    globalImageLink: '',
  };
  isOpen: boolean = false;
  isShowToday: isShowToday = {
    quick: dayjs().format('YYYY-MM-DD'),
    parcel: dayjs().format('YYYY-MM-DD'),
    registry: dayjs().format('YYYY-MM-DD'),
    global: dayjs().format('YYYY-MM-DD'),
  };
}

const Mutations: MutationTree<noticeState> = {
  updateNotice(state: noticeState, payload: notice) {
    state.notice.parcelImageUrl = payload.parcelImageUrl || '';
    state.notice.parcelImageLink = payload.parcelImageLink || '';
    state.notice.quickImageUrl = payload.quickImageUrl || '';
    state.notice.quickImageLink = payload.quickImageLink || '';
    state.notice.mailImageUrl = payload.mailImageUrl || '';
    state.notice.mailImageLink = payload.mailImageLink || '';
    state.notice.globalImageUrl = payload.globalImageUrl || '';
    state.notice.globalImageLink = payload.globalImageLink || '';
  },
  updateIsNoticeOpen(state: noticeState, payload: boolean) {
    state.isOpen = payload;
  },
};
const Actions: ActionTree<noticeState, any> = {
  updateNotice({ commit }, payload: notice) {
    commit('updateNotice', payload);
  },
  updateIsNoticeOpen({ commit }, payload: boolean) {
    commit('updateIsNoticeOpen', payload);
  },
};
const Getters: GetterTree<noticeState, any> = {
  getNoticeInfo: (state: noticeState) => {
    return state.notice;
  },
  getNoticeIsOpen: (state: noticeState) => {
    return state.isOpen;
  },
  getNoticeIsShowToday: (state: noticeState) => {
    return state.isShowToday;
  },
};

const module: Module<noticeState, any> = {
  namespaced: true,
  state: new noticeState(),
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
};

export default module;
